module.exports = __webpack_public_path__ + "static/media/green_vip.6d52e7a9.svg";